var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.667 17.333H9.333V20H8v-2.667H4V16h4v-2.667H4V12h4V9.333H4V8h16v1.333h-4V12h4v1.333h-4V16h4v1.333h-4V20h-1.333zm0-1.333H9.333v-2.667h5.334zm0-4H9.333V9.333h5.334zM4 6.678A2.68 2.68 0 0 1 6.678 4h10.644A2.68 2.68 0 0 1 20 6.678v10.644A2.68 2.68 0 0 1 17.322 20H6.678A2.68 2.68 0 0 1 4 17.322z",
  clipRule: "evenodd"
})));
export default SvgGemChannelCalendar;